import PROFILE_ROUTES from '@/presentation/modules/profile/constants/routes';

const profileRoutes = [
	{
		name: PROFILE_ROUTES.profile.name,
		path: PROFILE_ROUTES.profile.path,
		meta: PROFILE_ROUTES.profile.meta,
		component: PROFILE_ROUTES.profile.component,
		children: [
			{
				name: PROFILE_ROUTES.profileEditPost.name,
				path: PROFILE_ROUTES.profileEditPost.path,
				meta: PROFILE_ROUTES.profileEditPost.meta,
				component: PROFILE_ROUTES.profileEditPost.component,
			},
			{
				name: PROFILE_ROUTES.profileSetting.name,
				path: PROFILE_ROUTES.profileSetting.path,
				meta: PROFILE_ROUTES.profileSetting.meta,
				component: PROFILE_ROUTES.profileSetting.component,
			},
			{
				name: PROFILE_ROUTES.profileCreatePost.name,
				path: PROFILE_ROUTES.profileCreatePost.path,
				meta: PROFILE_ROUTES.profileCreatePost.meta,
				component: PROFILE_ROUTES.profileCreatePost.component,
			},
			{
				name: PROFILE_ROUTES.profileArtist.name,
				path: PROFILE_ROUTES.profileArtist.path,
				meta: PROFILE_ROUTES.profileArtist.meta,
				component: PROFILE_ROUTES.profileArtist.component,
			},
			{
				name: PROFILE_ROUTES.profileService.name,
				path: PROFILE_ROUTES.profileService.path,
				alias: PROFILE_ROUTES.profileService.alias,
				meta: PROFILE_ROUTES.profileService.meta,
				component: PROFILE_ROUTES.profileService.component,
			},
			{
				name: PROFILE_ROUTES.profileChooseTime.name,
				path: PROFILE_ROUTES.profileChooseTime.path,
				meta: PROFILE_ROUTES.profileChooseTime.meta,
				component: PROFILE_ROUTES.profileChooseTime.component,
			},
			{
				name: PROFILE_ROUTES.profileReservationSummary.name,
				path: PROFILE_ROUTES.profileReservationSummary.path,
				meta: PROFILE_ROUTES.profileReservationSummary.meta,
				component: PROFILE_ROUTES.profileReservationSummary.component,
			},
		],
	},
];

export default profileRoutes;
